import React from 'react'
import PropTypes from 'prop-types'
import { useQuery } from '@apollo/client'

import { path } from 'ramda'
import LinearProgress from '@material-ui/core/LinearProgress'
import ContentUnavailable from '@components/content-unavailable'
import Error from '@components/error'
import GET_GROUP_EVENT_BY_SLUG from './query'
import GroupEventPage from './group-event-page'

const GroupEventQuery = (props) => {
  const { query } = props
  const { slug } = query
  const { data, loading, error } = useQuery(GET_GROUP_EVENT_BY_SLUG, {
    variables: {
      slug,
    },
    context: { clientName: 'coach-tools' },
  })
  if (error) {
    return <Error error={error} displayErrorType="page" />
  }
  if (loading) return <LinearProgress color="secondary" />
  const event = path(['groupEvents', '0'], data)

  if (!event) return <Error statusCode={404} />
  if (!event.coach.pgaCoachEligible) return <ContentUnavailable />

  return <GroupEventPage event={event} />
}

GroupEventQuery.propTypes = {
  query: PropTypes.shape({
    slug: PropTypes.string,
  }),
}

export default GroupEventQuery
